import { API_ROUTE_ADMIN_ASSETS_NEW } from '@/resources/api-routes'
import { post } from '@/util/auth'

const IS_NEW_BACKEND_API = true

type AddAssetPayloadOriginal = {
  assetDescription: string
  cost: number
  userTypeId: number | null
  userName: string | null
  statusId: number
  customerAddressId: number
  ownershipTypeId: number
  comment: string
  typeId: number
  ecomPolicyId: number | null
  imeiSnr: string
  customerId: number
  costObjectId?: number
  received: string
  imeiNumber: string
  serialNumber: string
}
type AddAssetResponseOriginal = {
  active: boolean
  assetDescription: string
  comment: string
  cost: number
  costObjectId: number
  createdDate: string
  createdUserId: number
  customerAddressId: number
  customerId: number
  dealerUserId: null | number
  deleteCertificate: null | string
  deleteCertificateDate: null | string
  departmentId: null | number
  devicePolicyProductId: null | number
  ecomOrderId: number
  ecomOrderlineId: null | number
  ecomProductId: null | number
  editedDate: null | string
  editedUserId: null | number
  id: number
  imeiSnr: string
  incomingInvoiceId: null | number
  isLeased: boolean
  leaseStart: null | string
  leaseEnd: null | string
  leasingVendorId: null | number
  onboardingOrderId: null | number
  orderId: null | number
  outgoingInvoiceId: null | number
  ownershipId: number
  received: null | string
  result: null | string
  resultCost: null | number
  returnStatusId: null | number
  statusId: number
  typeId: number
  userTypeDescription: string
  userTypeId: number
}

export async function addAsset(payload: AddAssetPayloadOriginal) {
  return post<AddAssetResponseOriginal>(API_ROUTE_ADMIN_ASSETS_NEW, payload, IS_NEW_BACKEND_API)
}

export type AddAssetPayload = Parameters<typeof addAsset>[number]
export type AddAssetReturnType = Awaited<ReturnType<typeof addAsset>>
